export default "__VITE_ASSET__6cd315aa__"